export default __webpack_public_path__ + "static/media/25_TopLeftSquares_RotateRight.51aaae1a.mp4";